/*
 * „Rezolvare estimată în 10 minute" — fraza care se spune unui om.
 *
 * ---------------------------------------------------------------------------
 * DE CE NU VINE GATA DE LA API
 * ---------------------------------------------------------------------------
 *
 * Api-ul trimite NUMĂRUL, `self_serve_minutes`, și atât. Fraza e text de
 * interfață: are o formă în română și alta în engleză, iar compusă pe server ar
 * fi plecat într-o singură limbă și pagina n-ar mai fi avut ce traduce.
 *
 * ---------------------------------------------------------------------------
 * DE CE NU TRECE PRIN t()
 * ---------------------------------------------------------------------------
 *
 * `t()` schimbă o propoziție cu alta; aici propoziția are un număr în ea, iar
 * numărul îi schimbă forma. În română, numerele ale căror ultime două cifre
 * sunt între 1 și 19 merg direct — „12 minute" — iar restul cer „de": „20 de
 * minute", „21 de minute". Regula asta nu încape într-o cheie de dicționar, și
 * lăsată pe seama celui care afișează, jumătate din locuri ar fi scris
 * „20 minute".
 *
 * ---------------------------------------------------------------------------
 * GOL RĂMÂNE GOL
 * ---------------------------------------------------------------------------
 *
 * `null` înseamnă „nimeni n-a măsurat", și atunci nu se spune nimic. Timpul e o
 * promisiune: dacă articolul îi ia omului douăzeci și cinci de minute în loc de
 * zece, a doua oară nu mai citește niciunul. Un implicit ar fi fost o cifră
 * inventată, iar pe ecran nu se vede care cifră e măsurată și care inventată.
 */

import { getLang } from './i18n';

/**
 * Cât îi ia omului, spus în limba paginii. Șirul gol când nu se știe.
 */
export function solveTimeLabel(minutes: number | null | undefined): string {
  const value = Number(minutes);

  if (!Number.isFinite(value) || value < 1) return '';

  if (getLang() === 'en') {
    return `You solve it in about ${value} ${value === 1 ? 'minute' : 'minutes'}`;
  }

  const lastTwo = value % 100;
  const unit =
    value === 1 ? 'minut' : lastTwo >= 1 && lastTwo <= 19 ? 'minute' : 'de minute';

  /*
   * „Rezolvi", nu „Rezolvare estimată".
   *
   * Prima formă era numele unui câmp — o măsurătoare despre articol. Asta i se
   * adresează omului și îi spune ce face EL: cine citește „rezolvi în cinci
   * minute" se apucă, cine citește „rezolvare estimată" citește o etichetă.
   */
  return `Rezolvi estimativ în ${value} ${unit}`;
}
